export default {
  companyScoreMetadata: {
    noTeams:
      'Кнопка «Назначить оценку» станет доступна после создания хотя бы одной команды и добавления в неё сотрудников на вкладке',
    tableHeaders: {
      evaluated: 'Оцениваемый',
      team: 'Команда',
      specialty: 'Специализация',
      skills: 'Навыки',
      progress: 'Прогресс',
      statistics: 'Статистика',
      test: 'Тест',
      type: 'Тип',
      appointed: 'Назначен',
      completed: 'Пройден',
      approvalStatus: 'Статус',
      result: 'Результат',
      edit: 'Ред.',
    },
    successMessages: {
      createReminders: 'Напоминания успешно отправлены',
      setHiddenReports360:
        'Возможность просмотра отчётов у оцениваемых сотрудников успешно изменена',
      closeTests360: {
        close: 'Выбранные тесты успешно закрыты для прохождения',
        open: 'Выбранные тесты успешно открыты для прохождения',
      },
      deleteTests360: 'Выбранные тесты успешно удалены',
    },
    errorMessages: {
      report: 'Пользователь ещё не прошел оценку, отчёт не был сформирован',
      roadmap: 'Пользователь ещё не прошел оценку, план развития не был сформирован',
      createRoadmap: 'Не удалось сформировать план развития',
      createReminders: 'Не удалось отправить напоминания',
      setHiddenReports360:
        'Не удалось изменить возможность просмотра отчётов у оцениваемых сотрудников',
      closeTests360: {
        close: 'Не удалось закрыть для прохождения выбранные тесты',
        open: 'Не удалось открыть для прохождения выбранные тесты',
      },
      deleteTests360: 'Не удалось удалить выбранные тесты',
      getVariantsPersonalReport: 'Не удалось получить варианты отчётов',
      getLinkPersonalReport: 'Не удалось получить ссылку на отчёт',
    },
  },
};
